import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Roboto-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

Font.register({
  family: "Oswald",
  src: "/fonts/Oswald-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Oswald-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    gap: 10,
    backgroundColor: "#fff",
    fontFamily: "Roboto",
    padding: 10,
  },
  section: {
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
    padding: 10,
  },
  titleText: {
    fontFamily: "Oswald",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
  },
  subtitleText: {
    fontFamily: "Roboto",
    textAlign: "center",
    fontWeight: "normal",
    fontSize: 12,
  },
  normalText: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal",
    textAlign: "left",
  },
  tableView: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 5,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    backgroundColor: "#ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "normal",
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
});

export default function VendasIngressosPDF({ data, grupoIngresso }) {
  return (
    <Document
      creationDate={new Date()}
      author="Santa Ficha"
      title={`Vendas Ingressos - Grupo Ingressos ${grupoIngresso} - ${new Date().toLocaleDateString(
        "pt-BR",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }
      )}`}
      subject="Vendas Ingressos"
      keywords="relatório, vendas, ingressos, santa ficha"
      producer="Santa Ficha"
      creator="Santa Ficha"
      language="pt-BR"
    >
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.titleText}>
            Vendas Ingressos - Grupo {grupoIngresso}
          </Text>
          <Text style={styles.subtitleText}>
            Emitido em{" "}
            {new Date().toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Text>
        </View>

        <View style={styles.tableView}>
          <View style={styles.tableHeader}>
            <Text style={{ width: "20%" }}>Grupo</Text>
            <Text style={{ width: "20%" }}>Código SC</Text>
            <Text style={{ width: "10%" }}>QR Code</Text>
            <Text style={{ width: "20%" }}>Data/Hora de Emissão</Text>
            <Text style={{ width: "10%" }}>Operador</Text>
            <Text style={{ width: "10%" }}>PDV</Text>
            <Text style={{ width: "10%" }}>Forma de Pagamento</Text>
          </View>

          {data?.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={{ width: "20%" }}>{row?.GRUPOINGRESSO}</Text>
              <Text style={{ width: "20%" }}>{row.CODINGRESSO}</Text>
              <Text style={{ width: "10%" }}>{row?.QRCODE}</Text>
              <Text style={{ width: "20%" }}>
                {new Intl.DateTimeFormat("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(row.DATAHORA))}
              </Text>
              <Text style={{ width: "10%" }}>{row?.RESPONSAVEL}</Text>
              <Text style={{ width: "10%" }}>{row?.CODPDV}</Text>
              <Text style={{ width: "10%" }}>
                {row.FORMASPAGAMENTO[0]?.FORMAPGTO}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}
